<template>
  <div class="back">
    <div class="back_image" ref="homePage">
      <!-- 返回首页Btn -->
      <div class="indexBtn" @click="toIndex">
        <el-button type="warning" icon="el-icon-s-home" size="mini" round>返回首页</el-button>
      </div>
      <div class="cataBtn" @click="catalogBtn">
        <el-button type="primary" icon="el-icon-notebook-2" size="mini" round>目录</el-button>
      </div>
      <!-- 遮罩层 -->
      <div>
        <div
          class="catalog"
          ref="homePage2"
          @click="catalogShow = false"
          v-show="catalogShow  == true"
        >
          <div class="catalog_con" @click.stop="catalogShow = true">
            <!-- 关闭按钮 -->
            <div class="closeBtn" @click.stop="catalogShow = false">
              <el-button icon="el-icon-close" circle></el-button>
            </div>
            <!-- 目录 -->
            <div class="catalog_p">
              <div
                v-for="(item,i) in catalogList"
                :key="i"
                :class="item.isChoose == true?'catalog_p_item2':'catalog_p_item'"
                @click.stop="catalogItem(item.pageCount)"
              >{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 主要显示图片位置 -->
      <div class="paddingDiv">
        <transition name="el-zoom-in-center">
          <img :src="imageSrc" alt class="pptImage" v-show="imageShow" />
        </transition>
      </div>
      <!-- 切换页面按钮 -->
      <div class="disDiv">
        <div class @click="previousPage">
            <el-button type="warning" icon="el-icon-arrow-left">上一页</el-button>
        </div>
        <div class @click="nextPage">
           <el-button type="warning">下一页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  created() {
    // this.screenfull();
  },
  data() {
    return {
      clientHeight: "",
      catalogShow: false,
      imageSrc: require("../../assets/images/padImage/ppt/1.jpg"),
      imageShow: true,
      catalogList: [
        { name: "首页", isChoose: true, pageCount: 1 },
        { name: "保康县综合演练情况介绍", isChoose: false, pageCount: 3 },
        { name: "指挥中心融合通信系统介绍 ", isChoose: false, pageCount: 5 },
        { name: "现场应急通讯设备介绍 ", isChoose: false, pageCount: 8 },
        { name: "科尔融合通讯系统特色", isChoose: false, pageCount: 15 }
      ],
      pageList: [
        {
          url: require("../../assets/images/padImage/ppt/1.jpg"),
          isChoose: true,
          pageCount: 1
        },
        {
          url: require("../../assets/images/padImage/ppt/2.jpg"),
          isChoose: false,
          pageCount: 2
        },
        {
          url: require("../../assets/images/padImage/ppt/3.jpg"),
          isChoose: false,
          pageCount: 3
        },
        {
          url: require("../../assets/images/padImage/ppt/4.jpg"),
          isChoose: false,
          pageCount: 4
        },
        {
          url: require("../../assets/images/padImage/ppt/5.jpg"),
          isChoose: false,
          pageCount: 5
        },
        {
          url: require("../../assets/images/padImage/ppt/6.jpg"),
          isChoose: false,
          pageCount: 6
        },
        {
          url: require("../../assets/images/padImage/ppt/7.jpg"),
          isChoose: false,
          pageCount: 7
        },
        {
          url: require("../../assets/images/padImage/ppt/8.jpg"),
          isChoose: false,
          pageCount: 8
        },
        {
          url: require("../../assets/images/padImage/ppt/9.jpg"),
          isChoose: false,
          pageCount: 9
        },
        {
          url: require("../../assets/images/padImage/ppt/10.jpg"),
          isChoose: false,
          pageCount: 10
        },
        {
          url: require("../../assets/images/padImage/ppt/11.jpg"),
          isChoose: false,
          pageCount: 11
        },
        {
          url: require("../../assets/images/padImage/ppt/12.jpg"),
          isChoose: false,
          pageCount: 12
        },
        {
          url: require("../../assets/images/padImage/ppt/13.jpg"),
          isChoose: false,
          pageCount: 13
        },
        {
          url: require("../../assets/images/padImage/ppt/14.jpg"),
          isChoose: false,
          pageCount: 14
        },
        {
          url: require("../../assets/images/padImage/ppt/15.jpg"),
          isChoose: false,
          pageCount: 15
        },
        {
          url: require("../../assets/images/padImage/ppt/16.jpg"),
          isChoose: false,
          pageCount: 16
        }
      ]
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.clientHeight = `${document.documentElement.clientHeight}`; //document.body.clientWidth;
    //console.log(self.clientHeight);
    window.onresize = function temp() {
      this.clientHeight = `${document.documentElement.clientHeight}`;
    };
  },
  watch: {
    // 如果 `clientHeight` 发生改变，这个函数就会运行
    clientHeight: function() {
      this.changeFixed(this.clientHeight);
    }
  },
  methods: {
     previousPage() {
      this.imageShow = false;
      var url = this.imageSrc;
      for (var i = 0; i < this.pageList.length; i++) {
        if (this.pageList[i].url == url) {
          if (i > 0) {
            // console.log(i);
            this.imageSrc = this.pageList[i - 1].url;
            for (var l = 0; l < this.catalogList.length; l++) {
              this.catalogList[l].isChoose = false;
              if (i <=2) {
                this.catalogList[0].isChoose = true;
              }else if(i>= 2 && i<5){
                this.catalogList[1].isChoose = true;
              }else if(i>=5 && i<8 ){
                this.catalogList[2].isChoose = true;
              }else if(i>=8 && i<15){
                this.catalogList[3].isChoose = true;
              }else if(i>=15){
                this.catalogList[4].isChoose = true;
              }
            }
          } else {
            console.log("indexPage");
          }
        }
      }
      setTimeout(() => {
        this.imageShow = true;
      }, 150);
    },
    // 下一页
    nextPage() {
      this.imageShow = false;
      var url = this.imageSrc;
      for (var i = 0; i < this.pageList.length; i++) {
        if (this.pageList[i].url == url) {
                console.log(i)
          if (i < this.pageList.length - 1) {
            this.imageSrc = this.pageList[i + 1].url;
            for (var l = 0; l < this.catalogList.length; l++) {
              this.catalogList[l].isChoose = false;
              if (i < 1) {
                this.catalogList[0].isChoose = true;
              }else if(i>= 1 && i<3){
                this.catalogList[1].isChoose = true;
              }else if(i>=3 && i<=5 ){
                this.catalogList[2].isChoose = true;
              }else if(i>=6 && i<=13){
                this.catalogList[3].isChoose = true;
              }else if(i>=14){
                this.catalogList[4].isChoose = true;
              }
            }
          } else {
            console.log("lastPage");
          }
        }
      }
      setTimeout(() => {
        this.imageShow = true;
      }, 150);
    },
    catalogItem(c) {
      this.imageShow = false;
      console.log(c);
      for (var i = 0; i < this.catalogList.length; i++) {
        this.catalogList[i].isChoose = false;
        if (this.catalogList[i].pageCount == c) {
          this.catalogList[i].isChoose = true;
        }
      }
      for (var i = 0; i < this.pageList.length; i++) {
        this.pageList[i].isChoose = false;
        if (this.pageList[i].pageCount == c) {
          this.imageSrc = this.pageList[i].url;
          this.pageList[i].isChoose = true;
        }
      }
      this.catalogShow = false;
      setTimeout(() => {
        this.imageShow = true;
      }, 150);
      console.log(this.imageShow);
    },
    changeFixed(clientHeight) {
      //动态修改样式
      console.log(clientHeight);
      this.$refs.homePage.style.height = clientHeight + "px";
      this.$refs.homePage2.style.height = clientHeight + "px";
      this.$refs.homePage2.style.paddingBottom= "150px";
    },
    toIndex() {
      this.$router.push({ path: "/pad_index" });
    },
    catalogBtn() {
      this.catalogShow = true;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.back_image {
  width: 100%;
  background-image: url("../../assets/images/padImage/indexBacGround.jpg");
  background-size: 100% 100%;
  padding-bottom: 100px;
}
.pptImage {
  width: 80%;
  margin-top: 100px;
  margin-left: 10%;
  z-index: 888;
  height: 350px;
}
.indexBtn {
  position: fixed;
  top: 5%;
  right: 16%;
}
.cataBtn {
  position: fixed;
  top: 5%;
  right: 5%;
}

.catalogBtn {
  position: fixed;
  top: 11%;
  right: 3%;
}
.previousBtn {
  position: fixed;
  bottom: 5%;
  right: 3%;
}
.nextBtn {
  position: fixed;
  bottom: 11%;
  right: 3%;
}
.catalog {
  width: 100%;
  background-color: rgba(00, 00, 00, 0.5);
  position: fixed;
  z-index: 999;
}
.catalog_con {
  width: 90%;
  height: 100%;
  margin-left: 10%;
  background-color: rgba(33, 33, 33, 1);
  padding-bottom: 150px;
}
.closeBtn {
  position: absolute;
  top: 3%;
  right: 3%;
}
.catalog_p {
  width: 80%;
  margin: 0 auto;
  color: #fff;
  font-size: 22px;
  padding-top: 15%;
}
.catalog_p_item {
  margin-top: 20px;
}
.catalog_p_item2 {
  margin-top: 20px;
  color: #f98329;
}
.disDiv{
  width: 30%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pad/pad_ppt.vue